export default __webpack_public_path__ + "static/media/auteuil2.3cf9919f.jpg";